import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { ParamsClean } from '@/common/decorators/params-clean'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ExaminationDetailService, OrderOption, ExaminationDetail } from '../../_components/examination/examination-detail.service'

export interface QueryParams {
  group_id?: number // 分组id
  alert_type?: number // 预警类型，1-体检预警、2-病毒预警、3-CPU占用预警、4-内存占用预警、5-CPU温度预警、6-磁盘温度预警、7-上传网速预警、8-下载网速预警、9-系统盘占用预警、10-磁盘总体占用预警
  key_word?: string // 搜索关键词
  start_time?: number // 开始时间
  end_time?: number // 结束时间
  // sort?: string // 排序字段
  // asc?: boolean // 顺序,true-正序,false-逆序
  page?: number
  limit?: number
  /** 前端字段 */
  dateRange?: any[]
}

/** 预警类型筛选项 value，与接口 alert_type 一致（0-10） */
export const ALERT_HISTORY_ALERT_TYPE_VALUES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const

export interface ExamDetail {
  time: number // 时间戳
  task_id: string // 任务/批次ID
  order_id: string // 指令id
  score: number // 体检分数
  'speed.start': number // 电脑加速.开机加速
  'speed.network': number // 电脑加速.网络加速
  'speed.system': number // 电脑加速.系统加速
  'system.network': number // 系统异常.网络设置
  'system.browser': number // 系统异常.浏览器安全
  'system.problem': number // 系统异常.系统问题
  'virus.system': number // 病毒木马.系统安全
  'virus.mobile_devices': number // 病毒木马.移动设备
  'garbage.game': number // 电脑垃圾.游戏垃圾
  'garbage.register': number // 电脑垃圾.注册表垃圾
  'garbage.useless': number // 电脑垃圾.无用软件
  'garbage.movie': number // 电脑垃圾.影音垃圾
  'garbage.network': number // 电脑垃圾.上网垃圾
  'garbage.system': number // 电脑垃圾.系统垃圾
  'garbage.talk': number // 电脑垃圾.聊天垃圾
  'garbage.uninstall': number // 电脑垃圾.卸载残留
  'garbage.other': number // 电脑垃圾.其他垃圾
  'guard.system': number // 电脑防护.系统防护
  'guard.shop': number // 电脑防护.网购保护
  'guard.homepage': number // 电脑防护.主页保护
  'softpromotion.': number // 软件精华.软件净化
}

export interface DeviceStatusDetail {
  time: number // 时间戳
  order_id: string // 指令id
  'cpu.percent': number // cpu使用率
  'memory.used': number // 内存使用量
  'memory.total': number // 内存最大量
  'card_disk.system.used': number // 系统盘使用量
  'card_disk.system.total': number // 系统盘最大量
  'card_disk.whole.used': number // 全部盘使用量
  'card_disk.whole.total': number // 全部盘最大量
  'network.flow.realtime.up': number // 实时网速上行
  'network.flow.realtime.down': number // 实时网速下行
  'network.flow.interval.up': number // 今日总流量上行
  'network.flow.interval.down': number // 今日总流量下行
  'cpu.current.temperature': number // cpu温度
  'disk.current.temperature': number // 磁盘温度
}

export interface List {
  device_id: string // 终端id
  computer_name: string // 计算机名
  user_mark: string // 登记用户名
  group_id: number // 分组id
  group_name: string // 分组名
  create_time: number // 时间
  alert_msg: string // 预警信息
  alert_type: number // 预警类型
  alert_time: number // 预警时间
  alert_detail: string
  data_count: number
  data_detail: ExamDetail | DeviceStatusDetail // 预警详情
  template_id?: number
  /** 模板占位符 JSON 字符串，如 {"count":"13"} */
  variables?: string
}

export interface ResponseData {
  list?: List[]
  total?: number // 总数
}

@Injectable()
export class WarningInfomationService implements ExaminationDetailService {
  constructor (private http: Http) {}

  @ParamsClean()

  @InvokeThrottle()
  getList (data: QueryParams) {
    return this.http.post<ResponseData>('/logmanage/alert-history/list', data).then(response => {
      const list = response.list || []
      response.list = list
      list.forEach(item => {
        if (item.alert_detail) {
          Object.assign(item, JSON.parse(String(item.alert_detail)))
        }

        const detail: ExamDetail = JSON.parse(String(item.data_detail))
        item.data_detail = detail
      })

      return response
    })
  }
  download (type: 0|1, options: QueryParams, moduleName: string) {
    const params = Object.assign({}, options, {
      file_type: type,
      page: 0, // 不分页
      limit: 0
    })
    return this.http.downloadWithBlob('/logmanage/alert-history/list/export', params, moduleName)
  }

  fetchExaminationDetails (deviceId: string): Promise<ExaminationDetail> {
    console.log('deviceId: ', deviceId)
    return Promise.resolve(undefined)
  }

  repairTerminal (option: OrderOption) {
    return this.http
      .post('/terminal-order/repair', option)
  }
}
